module.exports = __webpack_public_path__ + "static/media/jaidyn.f8b092f1.jpg";